module.exports = __webpack_public_path__ + "static/media/Fútbol_Club_Atlas.7184fb7f.png";